import { React, createContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { getData } from 'src/consumer/services/profileService'
import { getAllRolesInBoolean } from 'src/mentor/layout/utils'

export const BusinessProfileContext = createContext(null)

export function BusinessProfileProvider({ children }) {
  const navigate = useNavigate()
  const [profileData, setProfileData] = useState()
  const [businessCustomerDetails, setBusinessCustomerDetails] = useState({})
  const [businessCustomerPersonalDetails, setBusinessCustomerPersonalDetails] = useState({})
  const [profileContextLoading, setProfileContextLoading] = useState(false)

  const availableRoles = getAllRolesInBoolean()

  async function getAndSetUserProfileData() {
    const resp = await getData('/api/secure/user/profile')
    if (resp?.status === 200) {
      localStorage.setItem('authorities', JSON.stringify(resp?.data?.authorities))
      setProfileData({
        ...(resp?.data || {}),
      })
    }
  }

  async function getBusinessCustomerDetails() {
    const resp = await getData('/api/secure/bc/details')
    if (resp?.status === 200) {
      setBusinessCustomerDetails(resp.data)
    }
  }

  async function getBusinessCustomerPersonalDetails() {
    const resp = await getData('/api/secure/bc/details/personal')
    if (resp?.status === 200) {
      setBusinessCustomerPersonalDetails(resp.data)
    }
  }

  async function Setup() {
    setProfileContextLoading(true)

    const promises = [getAndSetUserProfileData()]
    if (availableRoles.isBusinessCustomer) {
      promises.push(getBusinessCustomerDetails(), getBusinessCustomerPersonalDetails())
    }

    await Promise.all(promises)
    setProfileContextLoading(false)
  }

  function checkOnboarded() {
    if (profileData) {
      if (!availableRoles.isBusinessCustomer) navigate('/workplace/onboarding')
    }
  }

  useEffect(() => {
    Setup()
  }, [])

  useEffect(() => {
    checkOnboarded()
  }, [profileData])

  return (
    <BusinessProfileContext.Provider
      value={{
        profileData: { ...profileData },
        businessCustomerDetails,
        businessCustomerPersonalDetails,
        refreshProfileData: Setup,
        profileContextLoading,
      }}
    >
      {children}
    </BusinessProfileContext.Provider>
  )
}
